/**
 * Contrato del libro de Vuelve Mañana (docs/google-sheet-contract.md). Es el MISMO libro que usaban la web de
 * Apps Script y la app de iOS: no se cambia su forma. El orden de columnas lo manda la fila de cabeceras de cada
 * pestaña (se lee en vivo), no la posición.
 */

export const TABS = { sessions: 'Sessions', settings: 'Settings', wingChun: 'WingChun', routine: 'Rutina' } as const;

export const SESSION_HEADERS = [
  'id', 'date', 'floorCompletedAt', 'normalStartedAt', 'normalFinishedAt', 'sessionType', 'rounds', 'durationSeconds',
  'effort', 'activity', 'pain', 'painNote', 'note', 'nextDaySoreness', 'wantToReturn', 'recoveryLoggedAt', 'exerciseFeedback',
  // PWA: foto de la rutina del día (JSON). Se añade al final la primera vez que se escribe una sesión.
  'routineSnapshot',
  // PWA: duración del calentamiento en segundos (vacío si se saltó).
  'warmupSeconds',
] as const;

export const SETTINGS_HEADERS = ['key', 'value', 'description'] as const;

/** Una fila por práctica (la crea Sync.gs o, si falta, la propia app al escribir la primera). */
export const WINGCHUN_HEADERS = [
  'id', 'date', 'form', 'startedAt', 'completedAt', 'durationSeconds', 'isDailyMinimum', 'source', 'outcome', 'note', 'createdAt',
] as const;

/** Rutina editable: una fila por ejercicio (ver packages/domain/src/routine.ts). Quitar = active «No» (archivado). */
export const ROUTINE_HEADERS = ['id', 'section', 'order', 'name', 'measure', 'target', 'question', 'prompt', 'active'] as const;

/** Lo que se lee en cada sincronización. WingChun es opcional: si la pestaña no existe, Google rechazaría todo el lote. */
export const DATA_RANGES = { sessions: `${TABS.sessions}!A1:Z`, settings: `${TABS.settings}!A1:C` } as const;
export const OPTIONAL_RANGES = { wingChun: `${TABS.wingChun}!A1:Z`, routine: `${TABS.routine}!A1:Z` } as const;

export type Values = unknown[][];
export type WorkbookRanges = Record<keyof typeof DATA_RANGES, Values> & Record<keyof typeof OPTIONAL_RANGES, Values | null>;
